/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';

const materialsListSchema = [new schema.Entity('materials')];

export {
  materialsListSchema,
};
